import {chunk} from 'lodash';

export const chunkWithIndex = <T extends Array<unknown>>(
  items: T,
  chunkSize: number
) => {
  return chunk(items, chunkSize).map((chunkedItems, chunkIndex) =>
    chunkedItems.map((item, index): [number, T[number]] => [
      chunkIndex * chunkSize + index,
      item,
    ])
  );
};
